import FastAdvertCreationPage from "../FastAdvertCreationPage";
import FastSellerAdvertCreationPage from "../FastSellerAdvertCreationPage";
import IlanVerLanding from "../IlanVerLanding";
import Homepage from "../Homepage";

const MainPublicRoute = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "/hizli_ilan_olustur",
      component: FastAdvertCreationPage,
    },
    {
      path: "/satici/hizli-ilan",
      component: FastSellerAdvertCreationPage,
    },
    {
      path: "/ilan-ver",
      component: IlanVerLanding,
    },
    {
      path: "/",
      component: Homepage,
    },
  ],
};

export default MainPublicRoute;
